import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';

export enum importFileConfig {
    DICOM = 'DICOM',
    NOT_DICOM = 'NOT_DICOM'
}

@Component({
    selector: 'import-file',
    templateUrl: './import-file.component.html',
    styleUrls: ['./import-file.component.scss']
})
export class ImportFileComponent {

    @Input() acceptedTypeFile?: Array<string>;
    @Input() acceptFolder?: boolean;
    @Output() fileData: EventEmitter<FileList | File[]> = new EventEmitter();

    public isDragEnter: boolean = false;
    _acceptedTypeFile: string = '';

    onFileSelected(event) {
        const file: FileList = event.target.files;
        this.fileData.emit(file);
    }

    onDragOver(event: DragEvent) {
        event.stopPropagation();
        event.preventDefault();
        event.dataTransfer.dropEffect = 'copy';
    }

    async onDrop(event: DragEvent) {
        event.stopPropagation();
        event.preventDefault();
        this.isDragEnter = false;
        let files: File[] = [];

        let items = event.dataTransfer.items;

        for (let i = 0; i < items.length; i++) {
            let item = items[i].webkitGetAsEntry();
            let itemAsFile = items[i].getAsFile();

            if (item) {
                if (item.isDirectory) {
                    files = files.concat(await this.getFileFromDir(item));
                } else {
                    files.push(itemAsFile);
                }
            };
        };
        this.fileData.emit(files);
    }

    private async getFileFromDir(dirEntry): Promise<File[]> {
        return new Promise<File[]>((resolve, reject) => {
            let directoryReader = dirEntry.createReader();
            let files: File[] = [];

            let readEntries = () => {
                directoryReader.readEntries(async (entries) => {
                    if (entries.length === 0) {
                        resolve(files);
                    } else {
                        for (const entry of entries) {
                            if (entry.isFile) {
                                files.push(await this.getFile(entry));
                            } else if (entry.isDirectory) {
                                files = files.concat(await this.getFileFromDir(entry));
                            }
                        }
                        readEntries();
                    }
                }, reject);
            };
            readEntries();
        });
    }

    private async getFile(fileEntry): Promise<File> {
        try {
            return await new Promise((resolve, reject) => fileEntry.file(resolve, reject));
        } catch (err) {
            console.log('Errore nel recupero dei files dalla cartella: ', err);
        }
    }
   
}
